import { ChangeEvent } from 'react';
import { BsSearch } from 'react-icons/bs';

import { Container } from './styles';

interface IProps {
  handleInput(event: ChangeEvent<HTMLInputElement>): void;
  value: string;
}

export const SearchBar = ({ handleInput, value }: IProps) => (
  <Container>
    <span>
      <BsSearch />
    </span>
    <input placeholder="Pesquisa" onChange={handleInput} value={value} />
  </Container>
);
